import { render, staticRenderFns } from "./ReadOnlyEditor.vue?vue&type=template&id=891d14e2&scoped=true"
import script from "./ReadOnlyEditor.vue?vue&type=script&lang=js"
export * from "./ReadOnlyEditor.vue?vue&type=script&lang=js"
import style0 from "./ReadOnlyEditor.vue?vue&type=style&index=0&id=891d14e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891d14e2",
  null
  
)

export default component.exports